<template>
<v-container class="pa-0">
  <!-- Filters Section -->
  <v-sheet color="grey lighten-5" class="pa-6 mb-4 rounded-lg border">
    <v-row dense align="center">
      <v-col cols="12" md="6">
        <v-select
          v-model="groupFilter"
          :items="groups"
          :disabled="loading"
          item-text="name"
          item-value="id"
          label="Categoría de Costo"
          placeholder="Todas las categorías"
          outlined
          dense
          clearable
          prepend-inner-icon="fas fa-layer-group"
          hide-details
          class="modern-input"
          @change="() => { this.options.page = 1; fetch(); }"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          @keyup="searchTimeOut"
          :disabled="loading"
          label="Búsqueda rápida"
          placeholder="Nombre del item..."
          outlined
          dense
          prepend-inner-icon="fas fa-search"
          hide-details
          clearable
          class="modern-input"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-sheet>

  <!-- Costs Table -->
  <v-data-table
    :headers="headers"
    :items="costs"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalItems"
    @update:options="fetch"
    class="modern-table border rounded overflow-hidden elevation-0"
    :footer-props="{
      showFirstLastPage: true,
      itemsPerPageOptions: [5, 10, 20]
    }"
  >
    <template v-slot:item.name="{ item }">
      <div class="d-flex align-center py-2">
        <v-icon small class="mr-2" color="grey lighten-1">
          {{item.has_dimension ? 'fas fa-ruler-combined' : 'fas fa-tag'}}
        </v-icon>
        <div class="d-flex flex-column">
          <span class="body-2 font-weight-medium">{{item.name}}</span>
          <span v-if="item.has_dimension" class="caption info--text">
            {{item.height}} x {{item.width}} cm
          </span>
        </div>
      </div>
    </template>

    <template v-slot:item.unit_name="{ item }">
      <v-chip x-small outlined label color="grey darken-2">
        {{item.unit_name}}
      </v-chip>
    </template>

    <template v-slot:item.group_name="{ item }">
      <span class="caption grey--text text--darken-2">{{item.group_name}}</span>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn small color="success" icon @click.stop="add(item)" title="Añadir">
        <v-icon small>fas fa-plus-circle</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import {fetchCost, fetchGroups, fetchUnits} from '@/api/products'
import notifications from '@/utils/notifications'

export default {
  name: 'AddCost',
  props: {
    is_supply: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    costs: [],
    search: '',
    timer: null,
    loading: false,
    options: {},
    totalItems: 0,
    groups: [],
    units: [],
    groupFilter: '',
    headers: [
      { text: 'Descripción', value: 'name', align: 'start' },
      { text: 'Unidad', value: 'unit_name', align: 'start', width: '120' },
      { text: 'Grupo', value: 'group_name', align: 'start', width: '150' },
      { text: 'Acción', value: 'actions', align: 'center', sortable: false, width: '80' }
    ],
  }),
  methods: {
    add(item) {
      this.$emit('add', { ...item, qty: 1 })
    },
    async fetch() {
      if (this.loading) return
      this.loading = true
      
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      let sort = ''
      
      if (sortBy && sortBy.length > 0) {
        if (sortBy[0] == 'group_name') sort = 'group__name'
        else if (sortBy[0] == 'unit_name') sort = 'unit__name'
        else sort = sortBy[0]
        
        if (sortDesc[0]) sort = '-' + sort
      }

      const query = `ordering=${sort}&page=${page || 1}&page_size=${itemsPerPage || 5}&search=${this.search || ''}&is_supply=${this.is_supply}&group=${this.groupFilter || ''}&is_active=true`
      
      await fetchCost(query)
      .then((data) => {
        this.totalItems = parseInt(data.count)
        this.costs = data.results
      })
      .catch((err) => {
        notifications.showError('Error en carga de datos ' + err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    searchTimeOut() {  
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.options.page = 1
        this.fetch()
      }, 800)
    }
  },
  async mounted() {
    this.groups = await fetchGroups(this.is_supply)
    this.units = this.$store.getters.getUnits
    this.fetch()
  }
}
</script>

<style scoped>
.modern-input >>> .v-input__slot {
  border-radius: 8px !important;
  background-color: white !important;
}
.modern-table {
  border: 1px solid rgba(0,0,0,0.08) !important;
}
</style>